import { render, staticRenderFns } from "./segment-button.vue?vue&type=template&id=6e8417d1&"
import script from "./segment-button.vue?vue&type=script&lang=js&"
export * from "./segment-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports